import React from 'react';
import { shape, string } from 'prop-types';
import { Link } from 'react-router-dom';
import { Box } from 'theme-ui';
import { Popover } from 'react-tiny-popover';
import { Stack } from '@bedrock-layout/stack';
import { Close } from '@styled-icons/evaicons-solid/Close';
import { EllipsisHorizontal } from '@styled-icons/ionicons-sharp/EllipsisHorizontal';

function ActionPopover({ tenant: { identifier, branch } }) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    return setOpen(false);
  }, []);

  return (
    <Popover
      isOpen={open}
      positions={['right']}
      padding={10}
      reposition={false} // prevents automatic readjustment of content position that keeps your popover content within its parent's bounds
      onClickOutside={() => setOpen(false)} // handle click events outside of the popover/target here!
      content={(
        { position, nudgedLeft, nudgedTop } // you can also provide a render function that injects some useful stuff!
      ) => (
        <Box bg="background" variant="popover">
          <Stack gutter="lg">
            <Link to={{ pathname: `/management/tenant/${identifier}/${branch}/view` }}>View</Link>
            <Link to={{ pathname: `/management/tenant/${identifier}/${branch}/edit` }}>Edit</Link>
          </Stack>
        </Box>
      )}
    >
      <div onClick={() => setOpen(!open)}>
        {open && <Close width="24" color="primary" />}
        {!open && <EllipsisHorizontal width="24" />}
      </div>
    </Popover>
  );
}

export const ActionPopoverTypes = {
  tenant: shape({
    identifier: string.isRequired,
    branch: string.isRequired,
    name: string.isRequired,
  }),
};

ActionPopover.propTypes = ActionPopoverTypes;

export default ActionPopover;
